import { useEffect, useRef, useState } from "react";
import { DomShell } from "./_gameKit";
import AdReward from "./_adReward";

/** States: idle → ready (wait for green) → green (tap!) → result. */
export default function JixxeoReaction() {
  const [state, setState] = useState("idle"); // idle | ready | green | result | too_soon
  const [ms, setMs] = useState(0);
  const [best, setBest] = useState(() => Number(localStorage.getItem("jixxeo_reaction_best") || 0));
  const [history, setHistory] = useState([]);
  const startRef = useRef(0);
  const timeoutRef = useRef(0);

  const arm = () => {
    if (state === "green") {
      const t = performance.now() - startRef.current;
      setMs(Math.round(t));
      setState("result");
      setHistory((h) => [Math.round(t), ...h].slice(0, 5));
      if (!best || t < best) { setBest(Math.round(t)); localStorage.setItem("jixxeo_reaction_best", String(Math.round(t))); }
      return;
    }
    if (state === "ready") { setState("too_soon"); return; }
    // idle / result / too_soon → start again
    setState("ready");
    const delay = 900 + Math.random() * 2400;
    timeoutRef.current = setTimeout(() => {
      startRef.current = performance.now();
      setState("green");
    }, delay);
  };

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const bg = {
    idle: "#050510",
    ready: "#FF003C",
    green: "#39FF14",
    result: "#050510",
    too_soon: "#FFE300",
  }[state];
  const label = {
    idle: "Tap to start",
    ready: "Wait for green…",
    green: "TAP NOW",
    result: `${ms} ms`,
    too_soon: "Too soon! Tap to retry",
  }[state];

  const avg = history.length ? Math.round(history.reduce((a, b) => a + b, 0) / history.length) : 0;

  return (
    <DomShell title="Jixxeo Reaction Test" accent="#39FF14"
      chips={[["Best", best ? `${best}ms` : "—"], ["Avg (last 5)", avg ? `${avg}ms` : "—"]]}
      instructions="Tap when the screen turns GREEN — don't jump the gun"
    >
      <button onClick={arm}
        className="w-full aspect-[4/3] rounded-2xl flex items-center justify-center transition-colors"
        style={{ background: bg, boxShadow: state === "green" ? "0 0 60px rgba(57,255,20,0.6) inset" : "none" }}>
        <div className="text-center">
          <div className="font-heading font-black text-4xl md:text-5xl uppercase tracking-tighter"
            style={{ color: state === "ready" || state === "green" || state === "too_soon" ? "#050510" : "#fff" }}>
            {label}
          </div>
          {state === "result" && (
            <div className="mono text-xs mt-2 text-white/70">Tap to try again</div>
          )}
        </div>
      </button>
      {history.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1.5 justify-center">
          {history.map((h, i) => (
            <span key={i} className="mono text-[10px] px-2 py-1 rounded-full border border-white/10 text-white/60">
              {h}ms
            </span>
          ))}
        </div>
      )}
      {state === "result" && (
        <div className="mt-4 flex justify-center"><AdReward game="jixxeo-reaction" compact /></div>
      )}
    </DomShell>
  );
}
